import React, { useContext, useMemo, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Sider, Menu, Button } from "../../components/shared";
import { CloseOutlined } from "@ant-design/icons";
import { Drawer, Tag } from "antd";

import "./navbar.scss";
import { Liveline, LivelineMobile } from "../../assets/dark-theme";

import {
    LineChartOutlined,
} from "@ant-design/icons";

import {
    users,
    Signal_Data_New_1,
    Signal_Data_Scada1,
    admin,
    cells,
    controls,
    dashboard,
    equipment,
    facilities,
    historicalRunsIcon,
    liveHistoricalData,
    plug,
    products,
    rulesAndConfiguration,
    matrix,
    Alert,
    facilitiesGreyIcon,
    AdvancedController,
    VirtualSensor,
    LPP,
    MaterialTracking,
    LCPTrained,
    backTest,
    ProcessInsight
} from "../../assets/dark-theme";
import { FunctionOutlined } from "@ant-design/icons";

import { AbilityContext } from "../../components/shared/Can";
import { menuItemIsDisabled } from "../../components/shared/menu/MenuComponent";
import { userSelectionActions } from "../../state/features/userSelectionReducer";

// Type definitions
interface MenuItem {
    label: React.ReactNode;
    key: string;
    title: string;
    icon: React.ReactNode;
    children?: MenuItem[];
}

interface Facility {
    id: number;
    text: string;
    livelineFacilityId?: string;
}

interface UserSelection {
    facility: Facility;
    cell: any;
    product: any;
}

interface FacilityList {
    data: Facility[];
}

interface RootState {
    userSelection: UserSelection;
    facilityList: FacilityList;
}

interface LeftNavProps {
    onExpandMenu?: () => void;
    openKeys: string[];
    visibleSideMenu: boolean;
    mobileCollapse: boolean;
    isSmallScreen: boolean;
    isPortraitMode: boolean;
    onCollapseMenu?: () => void;
    selectedKey: string;
    closeMenu?: () => void;
}

const facilityListSelector: MenuItem = {
    label: "Select Facility",
    key: "facility_selector",
    title: "Select Facility",
    icon: (
        <img
            src={facilitiesGreyIcon}
            alt="Facility List"
            className="sideMenuLogo"
        />
    ),
};

export const navMenuItems: MenuItem[] = [
    {
        label: "Dashboard",
        key: "dashboard",
        title: "Dashboard",
        icon: <img src={dashboard} alt="Dashboard" className="sideMenuLogo" />,
    },
    {
        label: "Analytics",
        key: "oee-console",
        title: "Analytics",
        icon: (
            <LineChartOutlined
                className="sideMenuLogo"
                style={{ fontSize: "30px", color: "#c9c9c9" }}
            />
        ),
    },
    {
        label: "Admin",
        key: "general_admin",
        title: "Admin",
        icon: <img src={admin} alt="Admin" className="sideMenuLogo" />,
        children: [
            {
                label: "Facilities",
                key: "general_admin/facilities",
                title: "Facilities",
                icon: (
                    <img
                        src={facilities}
                        alt="Facilities"
                        className="sideMenuLogo"
                    />
                ),
            },
            {
                label: "Cells",
                key: "general_admin/cells",
                title: "Cells",
                icon: <img src={cells} alt="Cells" className="sideMenuLogo" />,
            },
            {
                label: "Equipment",
                key: "general_admin/equipment",
                title: "Equipment",
                icon: (
                    <img
                        src={equipment}
                        alt="equipment"
                        className="sideMenuLogo"
                    />
                ),
            },
            {
                label: "Products",
                key: "general_admin/products",
                title: "Products",
                icon: (
                    <img
                        src={products}
                        alt="products"
                        className="sideMenuLogo"
                    />
                ),
            },
            {
                label: "Users",
                key: "general_admin/users",
                title: "Users",
                icon: (
                    <img
                        src={users}
                        alt="users"
                        className="sideMenuLogo"
                        height={26}
                    />
                ),
            },
            {
                label: <span>Cell Layout <Tag color="blue" style={{ fontSize: 10, padding: "0 4px", lineHeight: "16px" }}>Beta</Tag></span>,
                key: "general_admin/cell-layout",
                title: "Cell Layout",
                icon: (
                    <img
                        src={cells}
                        alt="Cell Layout"
                        className="sideMenuLogo"
                    />
                ),
            },
        ],
    },
    {
        label: "Monitor",
        key: "live_historical_data",
        title: "Monitor",
        icon: (
            <img
                src={liveHistoricalData}
                alt="liveHistoricalData"
                className="sideMenuLogo"
            />
        ),
        children: [
            {
                label: <span>Signals: SCADA 1 <Tag color="blue" style={{ fontSize: 10, padding: "0 4px", lineHeight: "16px" }}>Beta</Tag></span>,
                key: "live_data/scada1",
                title: "SCADA 1",
                icon: (
                    <img
                        src={Signal_Data_Scada1}
                        alt="monitorScada1"
                        className="sideMenuLogo"
                    />
                ),
            },
            {
                label: "Signals: SCADA 2",
                key: "live_data/scada2",
                title: "SCADA 2",
                icon: (
                    <img
                        src={Signal_Data_New_1}
                        alt="monitorSignalData"
                        className="sideMenuLogo"
                    />
                ),
            },
            {
                label: "Historical Runs",
                key: "live_historical_data/historical_runs",
                title: "Historical Runs",
                icon: (
                    <img
                        src={historicalRunsIcon}
                        alt="historicalRuns"
                        className="sideMenuLogo"
                    />
                ),
            },
            {
                label: "Advanced Controllers",
                key: "live_historical_data/advanced_controllers",
                title: "Advanced Controllers",
                icon: (
                    <img
                        src={AdvancedController}
                        alt="advancedController"
                        className="sideMenuLogo"
                    />
                ),
            },
            {
                label: "Virtual Sensor",
                key: "live_historical_data/virtual_sensor",
                title: "Virtual Sensor",
                icon: (
                    <img
                        src={VirtualSensor}
                        alt="virtualSensor"
                        className="sideMenuLogo"
                    />
                ),
            },
            {
                label: "Live Services",
                key: "live_historical_data/live_services",
                title: "Live Services",
                icon: (
                    <img
                        src={plug}
                        alt="liveServices"
                        className="sideMenuLogo"
                    />
                ),
            },
        ],
    },
    {
        label: "Controls",
        key: "controls_admin",
        title: "Controls",
        icon: <img src={controls} alt="controls" className="sideMenuLogo" />,
        children: [
            {
                label: "Rules",
                key: "controls_admin/rules_configuration",
                title: "Rules Configuration",
                icon: (
                    <img
                        src={rulesAndConfiguration}
                        alt="rulesAndConfiguration"
                        className="sideMenuLogo"
                    />
                ),
            },
            {
                label: "Alerts",
                key: "controls_admin/alerts_configuration",
                title: "Alerts Configuration",
                icon: (
                    <img
                        src={Alert}
                        alt="alertsAndConfiguration"
                        className="sideMenuLogo"
                    />
                ),
            },
            {
                label: "Process Insight",
                key: "controls_admin/process_insight",
                title: "Process Insight",
                icon: (
                    <img src={ProcessInsight} alt="ProcessInsight" className="sideMenuLogo" />
                ),
            },
            {
                label: "State Action Matrix",
                key: "controls_admin/state_action_matrix",
                title: "State Action Matrix",
                icon: (
                    <img
                        src={matrix}
                        alt="rulesAndConfiguration"
                        className="sideMenuLogo"
                    />
                ),
            },
            {
                label: "P-Controller Tuning",
                key: "controls_admin/proportional_controller_tuning",
                title: "Proportional Controller Tuning",
                icon: (
                    <img
                        src={AdvancedController}
                        alt="proportionalControllerTuning"
                        className="sideMenuLogo"
                    />
                ),
            },
        ],
    },
    {
        label: 'Machine Learning',
        key: 'ml',
        title: 'Machine Learning',
        icon: <FunctionOutlined className='sideMenuLogo' style={{ fontSize: "30px", color: "#c9c9c9" }} />,
        children: [
            {
                label: 'Liveline Physics Packages',
                key: 'ml/lpp',
                title: 'Liveline Physics Packages',
                icon: <img src={LPP} alt='LPP' className='sideMenuLogo' />,
            },
            {
                label: 'Liveline Controls Packages',
                key: 'ml/lcp',
                title: 'Liveline Controls Packages',
                icon: <img src={LCPTrained} alt='LCPTrained' className='sideMenuLogo' />,
            },
            {
                label: 'Back Test',
                key: 'ml/backtest',
                title: 'Back Test',
                icon: <img src={backTest} alt='backTest' className='sideMenuLogo' />,
            },
        ],
    },
    {
        label: "Material Tracking",
        key: "material_tracking",
        title: "Material Tracking",
        icon: <img src={MaterialTracking} alt="MaterialTracking" className="sideMenuLogo" />,
    },
];

const LeftNav: React.FC<LeftNavProps> = ({
    onExpandMenu = () => {},
    openKeys,
    visibleSideMenu,
    mobileCollapse,
    isSmallScreen,
    isPortraitMode,
    onCollapseMenu = () => {},
    selectedKey,
    closeMenu = () => {},
}) => {
    const ability = useContext(AbilityContext);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userSelection = useSelector((state: RootState) => state?.userSelection);
    const facilityList = useSelector((state: RootState) => state?.facilityList);
    
    // Sort facility list to keep current selection at the top
    const facilityListMenu = [...facilityList?.data]?.sort((fA) =>
        userSelection
            ? userSelection.facility?.id === fA.id
                ? -1
                : 1
            : 1
    );

    // State for facility menu and mobile drawer
    const [isFacilityMenu, setIsFacilityMenu] = useState<boolean>(true);
    const [activeSubmenu, setActiveSubmenu] = useState<string | null>(null);

    const facilitySelectorMenuItem = useMemo(
        (): MenuItem => ({
            ...facilityListSelector,
            label: userSelection?.facility.text || facilityListSelector.label,
            children:
                facilityListMenu?.length >= 1 && isFacilityMenu
                    ? facilityListMenu.map((facility) => ({
                          label: facility.text,
                          key: `facility_selector/${facility.id}`,
                          title: `Select ${facility.text}`,
                          icon: <></>,
                      }))
                    : undefined,
        }),
        [facilityListMenu, userSelection?.facility, isFacilityMenu]
    );

    const accessibleMenuItems = useMemo(
        (): MenuItem[] =>
            navMenuItems.reduce(
                (prevMenuItems: MenuItem[], currMenuItem: MenuItem) => {
                    if (currMenuItem?.children?.length) {
                        const childItems = currMenuItem.children.filter(
                            ({ key }) => {
                                // TODO: remove once general_admin/cell-layout is added to DB role screens
                                if (key === 'general_admin/cell-layout') return true;
                                // TODO: remove once controls_admin/proportional_controller_tuning is added to DB role screens
                                if (key === 'controls_admin/proportional_controller_tuning') return true;
                                // TODO: remove once live_data/scada1 is added to DB role screens
                                if (key === 'live_data/scada1') return true;
                                // TODO: remove once live_data/scada2 is added to DB role screens
                                if (key === 'live_data/scada2') return true;
                                const isDisabled = !menuItemIsDisabled(
                                    key,
                                    ability,
                                    userSelection.facility?.livelineFacilityId
                                );
                                return isDisabled;
                            }
                        );

                        const retVal = [...prevMenuItems];

                        if (childItems.length) {
                            retVal.push({
                                ...currMenuItem,
                                children: childItems,
                            });
                        }

                        return retVal;
                    }

                    const retVal = [...prevMenuItems];

                    if (
                        !menuItemIsDisabled(
                            currMenuItem.key,
                            ability,
                            userSelection.facility?.livelineFacilityId
                        )
                    ) {
                        retVal.push(currMenuItem);
                    }
                    return retVal;
                },
                [facilitySelectorMenuItem]
            ),
        [ability, userSelection, facilitySelectorMenuItem]
    );

    const onSelectHandler = (): void => {
        localStorage.setItem("isFacilityMenu", "true");
        setIsFacilityMenu(true);
        if (isPortraitMode) {
            onCollapseMenu(); // Close drawer when item is selected
        }
    };

    // Handle facility selection
    const handleFacilitySelection = (subItemKey: string): void => {
        const matches = subItemKey.match(/(?<=facility_selector\/)[\S]*/);
        
        if (matches && matches.length) {
            const id = matches[0];
            const selectedFacility = facilityList?.data?.find((f: Facility) => f.id === parseInt(id));
            
            if (selectedFacility) {
                dispatch(userSelectionActions.setUserSelection({
                    facility: selectedFacility,
                    cell: {},
                    product: {},
                }));
                
                // Check if current page is disabled for new facility
                if (menuItemIsDisabled(selectedKey, ability, selectedFacility.livelineFacilityId)) {
                    navigate('/');
                }
            }
        }
    };

    // Handle menu item click in drawer
    const handleDrawerMenuItemClick = (item: MenuItem): void => {
        if (item.children && item.children.length > 0) {
            setActiveSubmenu(activeSubmenu === item.key ? null : item.key);
        } else {
            // Close drawer and navigate
            onCollapseMenu();
            setActiveSubmenu(null);
            navigate(`/${item.key}`);
            
            // Update localStorage
            localStorage.setItem("isFacilityMenu", "true");
            setIsFacilityMenu(true);
        }
    };

    // Handle submenu item click in drawer
    const handleDrawerSubItemClick = (subItem: MenuItem): void => {
        // Close drawer
        onCollapseMenu();
        setActiveSubmenu(null);
        
        // Update localStorage
        localStorage.setItem("isFacilityMenu", "true");
        setIsFacilityMenu(true);
        
        if (subItem.key.startsWith('facility_selector/')) {
            handleFacilitySelection(subItem.key);
        } else {
            navigate(`/${subItem.key}`);
        }
    };

    useEffect(() => {
        const handleStorageChange = (): void => {
            const newIsFacilityMenu = localStorage.getItem("isFacilityMenu") === "true";
            setIsFacilityMenu(newIsFacilityMenu);
        };

        window.addEventListener("isFacilityMenuChange", handleStorageChange);

        return () => {
            window.removeEventListener("isFacilityMenuChange", handleStorageChange);
        };
    }, []);

    // Render mobile drawer for portrait mode
    if (isPortraitMode) {
        return (
            <>
                <Drawer
                    title={
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <img src={Liveline} alt="Liveline" style={{ height: '30px' }} />
                            <Button
                                type="text"
                                icon={<CloseOutlined />}
                                onClickEvent={onCollapseMenu}
                                style={{ color: '#fff' }}
                            />
                        </div>
                    }
                    placement="left"
                    open={!mobileCollapse}
                    onClose={onCollapseMenu}
                    closable={false}
                    width={280}
                    styles={{
                        header: {
                            backgroundColor: '#001529',
                            borderBottom: '1px solid #303030',
                            padding: '12px 16px',
                        },
                        body: {
                            backgroundColor: '#001529',
                            padding: 0,
                        }
                    }}
                >
                    <div className="mobile-drawer-content">
                        {accessibleMenuItems.map((item: MenuItem) => (
                            <div key={item.key} className="drawer-menu-item">
                                <div
                                    className={`drawer-item-header ${
                                        selectedKey === item.key || activeSubmenu === item.key ? 'active' : ''
                                    }`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleDrawerMenuItemClick(item);
                                    }}
                                >
                                    <div className="drawer-item-content">
                                        <span className="drawer-item-icon">
                                            {React.cloneElement(item.icon as React.ReactElement, {
                                                style: { 
                                                    fontSize: "20px", 
                                                    color: (selectedKey === item.key || activeSubmenu === item.key) ? "#fff" : "#c9c9c9" 
                                                }
                                            })}
                                        </span>
                                        <span className="drawer-item-label">{item.label}</span>
                                    </div>
                                    {item.children && item.children.length > 0 && (
                                        <span className="drawer-item-arrow">
                                            {activeSubmenu === item.key ? '▼' : '▶'}
                                        </span>
                                    )}
                                </div>

                                {/* Submenu */}
                                {activeSubmenu === item.key && item.children && item.children.length > 0 && (
                                    <div className="drawer-submenu">
                                        {item.children.map((subItem: MenuItem) => (
                                            <div
                                                key={subItem.key}
                                                className={`drawer-subitem ${
                                                    selectedKey === subItem.key ? 'active' : ''
                                                }`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    handleDrawerSubItemClick(subItem);
                                                }}
                                            >
                                                <span className="drawer-subitem-icon">
                                                    {subItem.icon && React.cloneElement(subItem.icon as React.ReactElement, {
                                                        style: { 
                                                            fontSize: "16px", 
                                                            color: selectedKey === subItem.key ? "#fff" : "#c9c9c9" 
                                                        }
                                                    })}
                                                </span>
                                                <span className="drawer-subitem-label">{subItem.label}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </Drawer>
            </>
        );
    }

    // Regular sidebar for desktop
    return (
        <div
            className={`side-menu ${
                visibleSideMenu ? "alignLeftNavCollapse" : "alignLeftNav"
            } ${mobileCollapse ? "mobileCollpase" : ""}`}
        >
            <Sider
                width={"15vw"}
                breakpoint="lg"
                collapsible
                collapsed={visibleSideMenu}
                onCollapse={onCollapseMenu}
            >
                {isSmallScreen ? (
                    <a href="/">
                        <img
                            src={LivelineMobile}
                            className="logo"
                            alt="livelinelog"
                        />
                    </a>
                ) : (
                    <a href="/">
                        {visibleSideMenu ? (
                            <img
                                src={LivelineMobile}
                                className="logo"
                                alt="livelinelog"
                            />
                        ) : (
                            <img
                                src={Liveline}
                                className="logo"
                                alt="livelinelog"
                            />
                        )}
                    </a>
                )}

                <Menu
                    style={{
                        maxHeight: "calc(100vh - 117px)",
                        overflow: "auto",
                    }}
                    items={accessibleMenuItems}
                    openKeys={openKeys}
                    onOpenChange={onExpandMenu}
                    defaultSelectedKeys={[selectedKey]}
                    closeMenu={closeMenu}
                    onSelectHandler={onSelectHandler}
                />
            </Sider>
        </div>
    );
};

export default LeftNav;